export enum UsedCriteriaOutlineColorType {
  Positive = 'positive',
  Falsy = 'falsy',
  Negative = 'negative',
}